import React from 'react';
import {makeStyles} from "@material-ui/styles";
import {RTL,AlertDialog} from "../index";
import {Typography,Button} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import withStyles from "@material-ui/core/styles/withStyles";
import { useDispatch, useSelector } from 'react-redux';
import { axios } from './.../../../../axios';
import { showSnackbar } from 'redux/Action';

const useStyles = makeStyles(theme => ({
    dialogTitle:{
        '& > h2':{
            fontWeight:'bold'
        }
    },
    formControl:{
        marginTop:theme.spacing(4)
    }
}));

const ColorButton = withStyles(theme => ({
    root: {
        color: theme.palette.getContrastText( '#EC4E4F'),
        backgroundColor: '#EC4E4F',
        '&:hover': {
            backgroundColor: '#e51212',
        },
    },
}))(Button);

const DeleteDialog= props=> {
    const classes=useStyles();
    const {open,onClose,onAccept, id, type, reloadFunc}=props;


    const dispatch = useDispatch();

  const token = useSelector((state) => state.token);
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };


  const DeleteCompany = async () => {
  
    if(type=="Employee")
    {
        try{
            const res = await axios.delete(`staff/${id}`, {
              headers: headers,
            });
            dispatch(showSnackbar(true,'success','کارمند با موفقیت حذف شد'))
            reloadFunc();
            onClose();
       
          }catch(e)
          {
            // console.log(e.response,"eeeeeeeee")
           
          }
        
    }
    else if(type=="Company")
    {
        try{
            const res = await axios.delete(`companies/${id}`, {
              headers: headers,
            });
            dispatch(showSnackbar(true,'success','شرکت با موفقیت حذف شد'))
            reloadFunc();
            onClose();
      
          }catch(e)
          {
            // console.log(e.response,"eeeeeeeee")
           
          }
    }
    else if(type=="Driver")
    {
        try{
            const res = await axios.delete(`drivers/${id}`, {
              headers: headers,
            });
            dispatch(showSnackbar(true,'success','راننده با موفقیت حذف شد'))
            reloadFunc();
            onClose();
      
          }catch(e)
          {
            // console.log(e.response,"eeeeeeeee")
           
          }
    }
    
  
}



    return (
        <RTL>
            <AlertDialog
                fullWidth={true}
                onClose={onClose}
                onAccept={onAccept}
                maxWidth={'sm'}
                onAcceptText={    <ColorButton
                    variant="contained"
                    onClick={() => DeleteCompany()}

                    className={classes.button}
                >
                    <DeleteIcon style={{marginLeft:'8px'}} />
                    حذف
                </ColorButton>}
                onCloseText={
                    <Typography style={{color:'#aaa'}} variant="body1">
                        <b>
                            لفو
                        </b>
                    </Typography>
                }
                title={props.title} open={open}>
                <Typography variant="body1">
                    {props.desc}
                </Typography>
            </AlertDialog>
        </RTL>
    );
};

export default DeleteDialog;